// extracted by mini-css-extract-plugin
module.exports = {"menuLeft":"style_menuLeft__r6L6W","separator":"style_separator__3OUnU","language":"style_language__2DULe"};